export default function AdArt() {
    return (
        <span className="font-semibold tracking-[0.5em]"> ad<span className="font-bold">AR</span>t</span>
    )
}